import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CheckIcon from "@material-ui/icons/Check";
import { SectionWrapper } from "./MultiplesTenantSelector.styled";

const MultiplesTenantSelector = ({
  obj,
  index,
  data,
  formIndex,
  execFunctionAccount,
}) => {
  const [selectedValue, setSelectedValue] = useState(0);

  useEffect(() => {
    if (
      obj.type === "select" &&
      obj.data &&
      data !== undefined &&
      formIndex !== undefined
    ) {
      let newValue;
      if (
        obj.name === "client" &&
        obj.data.length > 0 &&
        data[formIndex]?.location?.clientId &&
        data.length > 0
      ) {
        newValue = data[formIndex]?.location?.clientId;
      }
      if (
        obj.name === "role" &&
        obj.data.length > 0 &&
        data[formIndex]?.role?.roleId &&
        data.length > 0
      ) {
        newValue = data[formIndex]?.role?.roleId;
      }
      if (
        obj.name === "country" &&
        obj.data.length > 0 &&
        data[formIndex]?.location?.countryId &&
        data.length > 0
      ) {
        newValue = data[formIndex]?.location?.countryId;
      }
      if (
        obj.name === "city" &&
        obj.data.length > 0 &&
        data[formIndex]?.location?.cityId &&
        data.length > 0
      ) {
        newValue = data[formIndex]?.location?.cityId;
      }
      if (
        obj.name === "supervisor" &&
        obj.data.length > 0 &&
        data[formIndex]?.supervisorId &&
        data.length > 0
      ) {
        newValue = data[formIndex]?.supervisorId;
      }
      if (
        obj.name === "isCoMoUser" &&
        obj.data.length > 0 &&
        data[formIndex]?.isCoMoUser &&
        data.length > 0
      ) {
        newValue =
          data[formIndex]?.isCoMoUser === true
            ? 1
            : data[formIndex]?.isCoMoUser === false
            ? 2
            : 0;
      }
      setSelectedValue(newValue);
    }
  }, [data, formIndex, obj.data, obj.data.length, obj.name, obj.type]);

  return (
    <SectionWrapper hidden={obj.hidden} key={index}>
      <label>
        {obj.label}
        {obj.mandatory && <span style={{ color: "red" }}> *</span>}
      </label>

      <select
        ref={obj.ref}
        name={obj.name}
        value={selectedValue}
        onChange={(e) => {
          setSelectedValue(e.target.value);
          execFunctionAccount(obj);
        }}
      >
        <option value={0}>--- Select an option ---</option>

        {obj.data.map((p, i) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>

      {obj.ref.current && obj.ref.current.value !== "0" && (
        <CheckIcon
          style={{
            color: "white",
            background: "rgba(51, 207, 141, 1)",
            borderRadius: "36px",
            fontSize: "13px",
            margin: "0px 3px",
          }}
        />
      )}
    </SectionWrapper>
  );
};

export default MultiplesTenantSelector;

MultiplesTenantSelector.propTypes = {
  obj: PropTypes.object,
  index: PropTypes.number,
  data: PropTypes.array,
  formIndex: PropTypes.number,
  execFunctionAccount: PropTypes.func,
};
